import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=a58e6d5c&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts&"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=a58e6d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58e6d5c",
  null
  
)

component.options.__file = "PrimaryButton.vue"
export default component.exports